import schoolPortalHttpCommon from "../helper/schoolPortalHttpCommon";

const removeEmptyParams = (params) => {
  return Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined,
    ),
  );
};

export const schoolGoogleLogin = (payload) => {
  return schoolPortalHttpCommon.post("school-portal/google/", payload, {
    skipAuth: true,
  });
};

export const fetchSchoolPortalMe = () => {
  return schoolPortalHttpCommon.get("school-portal/me/");
};

export const fetchSchoolPortalDashboard = ({ page, pageSize, search } = {}) => {
  const params = {};

  if (page !== undefined && page !== null && page !== "") {
    params.page = page;
  }

  if (pageSize !== undefined && pageSize !== null && pageSize !== "") {
    params.page_size = pageSize;
  }

  if (search !== undefined && search !== null && search !== "") {
    params.search = search;
  }

  return schoolPortalHttpCommon.get("school-portal/dashboard/", {
    params: removeEmptyParams(params),
  });
};

export const fetchSchoolPortalProfile = () => {
  return schoolPortalHttpCommon.get("school-portal/profile/");
};

export const updateSchoolPortalProfile = (formData) => {
  return schoolPortalHttpCommon.patch("school-portal/profile/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
